export enum DocumentStatus {
    draft = 1,
    active = 2,
    archived = 3,
    signed = 4,
}

export interface DocumentSaveModel {
    fileName: string;
}

export interface DocumentViewModel {
    id: string;
    fileName: string;
    dataId: string;
}
